export default {
    agreement_categories: "Келісім санаттары",
    app_code: "Бастамашы қосымшаның коды",
    authentication_login: "Аутентификация логині",
    authentication_password: "Аутентификация құпия сөзі",
    cod_no: "Код НО",
    credentials_of_authorized_person: "Уәкілетті тұлғаның авторласуы",
    director: "Директор",
    do_you_confirm_sending_feedback_url_to_patient_messenger: "Сіз мессенджерде пациентке пікір жазу сілтемесін жіберуді растайсыз ба?",
    do_you_confirm_sending_receipt_to_patient_messenger: "Пациентке түбіртек мессенджерге жіберілгенін растайсыз ба?",
    employee_login: "Қызметкердің логині",
    employee_password: "Қызметкердің құпия сөзі",
    fdoc_instruction: "Қызметтің дұрыс жұмыс істеуі үшін FDoc менеджеріне хоки/сұраулар алатын IP мекенжайын беріңіз: <code>{ipaddress}</code>. Сондай-ақ алғыңыз келетін оқиғаларды атаңыз: <code>SetStatus, SetStatusMessage, SetStatusPackageByClient</code>",
    fdoc_multiple_signers_instruction: "Бөлімде қызметкерді редакциялаудағы персонал FDoc қосымша бетінде FDoc жүйесінен қызметкердің логині мен құпия сөзі көрсетілуі тиіс.",
    files: "Файлдар",
    files_being_uploaded: "Файлдар қотарылуда. Жүктеу аяқталғанша бетті жаппаңыз.",
    fill_questionary: "Сауалнаманы толтыру",
    first_new: "Алдымен жаңалары",
    first_old: "Алдымен ескілері",
    gallery: "Галерея",
    header_in_akt: "Көрсетілген қызметтер актісінде қалпақ",
    multiple_signers_support: "Бірнеше қол қоюшыларды қолдау",
    options: "Опциялар",
    or_folder_with_dcm_files: "немесе DCM файлдары бар бума",
    select_folder: "Буманы таңдау",
    send_receipt_to_messenger: "Пациент мессенджеріне түбіртек жіберу",
    sign_selected_via_vendor: "{vendor} арқылы таңдалғанға қол қою",
    table: "Кесте"
}
